import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import 'slick-carousel';
gsap.registerPlugin(
    ScrollTrigger,
    MotionPathPlugin,
    ScrollSmoother,
    ScrollToPlugin
);

export function electricVehicleLaunch() {
    if (document.querySelector('.evl-loading-screen')) {
        window.addEventListener('load', () => {
            const loadingContainer = document.querySelector(
                '.evl-loading-screen'
            );

            loadingContainer.classList.add('evl-loading-screen-fade-out');
            setTimeout(() => {
                loadingContainer.classList.add('hidden');
            }, 600);
        });
    }

    if (document.querySelector('.evl-slider')) {
        $('.evl-slider').slick({
            swipe: true,
            slidesToShow: 3,
            dots: false,
            infinite: true,
            lazyLoad: 'ondemand',
            nextArrow: document.querySelector('.evl-slider-next'),
            prevArrow: document.querySelector('.evl-slider-prev'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    if (document.querySelector('body.run-on-electricity')) {
        const quoteButton = document.querySelector(
            '.evl-get-a-quote-container-button'
        );
        const ctaButton = document.querySelector('.evl-section-three-cta');
        const ctaButtonMobile = document.querySelector(
            '.evl-mobile-section-two-cta'
        );

        quoteButton.addEventListener('click', (e) => {
            e.preventDefault();
            gsap.to(window, 0, {
                duration: 3,
                scrollTo: '#evl-get-a-quote-container',
            });
        });

        ctaButton.addEventListener('click', (e) => {
            e.preventDefault();
            gsap.to(window, 0, {
                duration: 3,
                scrollTo: '#evl-get-a-quote-container',
            });
        });

        ctaButtonMobile.addEventListener('click', (e) => {
            e.preventDefault();
            gsap.to(window, 0, {
                duration: 3,
                scrollTo: '#evl-get-a-quote-container',
            });
        });

        ScrollSmoother.create({
            smooth: 1,
            effects: true,
            smoothTouch: 0.1,
        });

        const screenSize = gsap.matchMedia();

        screenSize.add('(max-width: 1023px)', () => {
            ScrollTrigger.normalizeScroll(false);

            gsap.set('.evl-mobile-section-one-grundon-title', {
                yPercent: -50,
                xPercent: -50,
                left: '50%',
                top: '50%',
                marginTop: '4.5vw',
            });
            gsap.set('.evl-mobile-grundon-title', {
                maxHeight: 500,
            });
            gsap.set('.evl-mobile-section-one-electricity', {
                top: '100%',
                fontSize: '15.3vw',
            });
            gsap.set('.evl-mobile-section-one-grundon-title .one', {
                width: '15.3vw',
            });
            gsap.set('.evl-mobile-section-one-grundon-title .second', {
                width: '15.3vw',
            });
            gsap.set('.evl-mobile-overlay', {
                top: '150%',
            });
            gsap.set('.evl-mobile-overlay-wording', {
                top: '0%',
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: '.evl-mobile-wrap',
                    start: 'top top',
                    end: '+=7000',
                    scrub: true,
                    pin: true,
                },
            })
                .to(
                    '.evl-mobile-section-one-grundon-title .one',
                    {
                        delay: 0.5,
                        opacity: 0,
                    },
                    'removal-of-letters-in-grundon-title-mobile'
                )
                .to(
                    '.evl-mobile-section-one-grundon-title .second',
                    {
                        delay: 0.5,
                        opacity: 0,
                    },
                    'removal-of-letters-in-grundon-title-mobile'
                )
                .to(
                    '.evl-mobile-next-chapter',
                    {
                        delay: 1,
                        opacity: 0,
                        duration: 2.5,
                    },
                    'removal-of-letters-in-grundon-title-mobile'
                )
                .to(
                    '.evl-mobile-lightsaber-container',
                    {
                        delay: 0,
                        top: '55%',
                        rotate: '-76deg',
                        left: '75%',
                        duration: 3,
                    },
                    'removal-of-letters-in-grundon-title-mobile'
                )
                .to(
                    '.evl-mobile-grundon-title',
                    {
                        left: '-8.5vw',
                        duration: 2.5,
                    },
                    'electricity-wording-entering-and-moving-mobile'
                )
                .to(
                    '.evl-mobile-section-one-electricity',
                    {
                        left: '0vw',
                        duration: 2.5,
                    },
                    'electricity-wording-entering-and-moving-mobile'
                )
                .to(
                    '.evl-mobile-section-one-grundon-title .one',
                    {
                        width: 0,
                        ease: 'none',
                        duration: 0.375,
                    },
                    'electricity-wording-entering-and-moving-mobile'
                )
                .to(
                    '.evl-mobile-section-one-electricity',
                    {
                        delay: 0.375,
                        fontSize: '19vw',
                        opacity: 1,
                        duration: 2.5,
                    },
                    'electricity-wording-entering-and-moving-mobile'
                )
                .to(
                    '.evl-mobile-lightsaber-container',
                    {
                        left: '78%',
                        rotate: '-152deg',
                        top: '33%',
                        duration: 3,
                    },
                    'electricity-wording-entering-and-moving-mobile'
                )
                .to(
                    '.evl-mobile-section-one-grundon-title .second',
                    {
                        width: '5vw',
                        duration: 1.5,
                    },
                    'electricity-wording-entering-and-moving-mobile'
                )
                .to(
                    '.evl-mobile-section-one-grundon-title .two',
                    {
                        marginLeft: '-8vw',
                        duration: 1.5,
                    },
                    'electricity-wording-entering-and-moving-mobile'
                )
                .to(
                    '.evl-mobile-section-one-grundon-title',
                    {
                        delay: 1,
                        marginTop: '0vw',
                        duration: 2,
                    },
                    'removal-run-on-mobile'
                )
                .to(
                    '.evl-mobile-grundon-title',
                    {
                        opacity: 0,
                        maxHeight: 0,
                        duration: 2,
                    },
                    'removal-run-on-mobile'
                )
                .to(
                    '.evl-mobile-section-one-electricity',
                    {
                        delay: 0.5,
                        top: '0%',
                        duration: 2,
                    },
                    'removal-run-on-mobile'
                )
                .to(
                    '.evl-mobile-lightsaber-container',
                    {
                        left: '50%',
                        rotate: '-206deg',
                        duration: 2,
                    },
                    'removal-run-on-mobile'
                )
                .to(
                    '.evl-mobile-section-one-large-dots-container',
                    {
                        opacity: 0.85,
                        duration: 1,
                    },
                    'scale-and-start-fade-mobile'
                )
                .to(
                    '.evl-mobile-section-one-grundon-title',
                    {
                        scale: 1.36,
                        duration: 1,
                        zIndex: 0,
                    },
                    'scale-and-start-fade-mobile'
                )
                .to(
                    '#evl-mobile-section-two',
                    {
                        opacity: 0.24,
                    },
                    'scale-and-start-fade-mobile'
                )
                .to(
                    '.evl-mobile-lightsaber-container',
                    {
                        top: '-100%',
                        left: '40%',
                        rotate: '-236deg',
                        duration: 2.5,
                    },
                    'scale-and-start-fade-mobile'
                )
                .to(
                    '.evl-mobile-lightsaber-container',
                    {
                        visibility: 'hidden',
                        delay: 2.5,
                        duration: 0,
                    },
                    'scale-and-start-fade-mobile'
                )
                .to(
                    '#evl-mobile-section-two img',
                    {
                        scale: 1.15,
                        bottom: '5%',
                    },
                    'scale-and-start-fade-mobile'
                )
                .to(
                    '.evl-mobile-truck',
                    {
                        scale: 1.15,
                        bottom: '5%',
                        opacity: 0.1,
                    },
                    'scale-and-start-fade-mobile'
                )
                .to(
                    '#evl-mobile-section-truck',
                    {
                        visibility: 'visible',
                    },
                    'scale-and-start-fade-mobile'
                )
                .to(
                    '.evl-mobile-section-one-electricity div',
                    {
                        opacity: 0,
                        delay: 2,
                        duration: 0.2,
                    },
                    'scale-and-start-fade-mobile'
                )
                .to(
                    '.evl-mobile-section-one-electricity-two',
                    {
                        delay: 0.7,
                        opacity: 1,
                        duration: 0.5,
                    },
                    'scale-and-start-fade-mobile'
                )
                .to('.evl-mobile-wrap section', 0.5, {
                    autoAlpha: 1,
                    stagger: 1,
                })
                .to('.evl-mobile-truck', {
                    opacity: 1,
                    duration: 2.5,
                })
                .to(
                    '#evl-mobile-section-two img',
                    {
                        duration: 3,
                        scale: 1.8,
                        bottom: '34%',
                        left: '60%',
                    },
                    'section-2-scale-mobile'
                )
                .to(
                    '.evl-mobile-truck',
                    {
                        duration: 3,
                        scale: 1.8,
                        bottom: '34%',
                        left: '58.9%',
                    },
                    'section-2-scale-mobile'
                )
                .to('.evl-mobile-truck', {
                    duration: 0.75,
                    scale: 1.8,
                });

            gsap.timeline({
                scrollTrigger: {
                    trigger: '.evl-mobile-wrap-2',
                    start: 'top top',
                    end: '+=4500',
                    scrub: true,
                    pin: true,
                    invalidateOnRefresh: true,
                },
            })
                .to(
                    '.evl-mobile-section-three-where-it-started',
                    {
                        opacity: 1,
                        duration: 2,
                    },
                    'where-it-started-coming-in-mobile'
                )
                .to(
                    '.evl-mobile-truck',
                    {
                        delay: 2,
                        bottom: '85%',
                        duration: 3,
                    },
                    'section-2-truck-up-mobile'
                )
                .to(
                    '.evl-mobile-section-three-where-it-started',
                    {
                        delay: 2,
                        opacity: 0,
                        duration: 2,
                    },
                    'section-2-truck-up-mobile'
                )
                .to(
                    '.evl-mobile-overlay',
                    {
                        delay: 2,
                        opacity: 1,
                        duration: 0,
                    },
                    'section-2-truck-up-mobile'
                )
                .to(
                    '.evl-mobile-overlay',
                    {
                        delay: 5,
                        top: '40%',
                        duration: 3.5,
                    },
                    'section-2-truck-up-mobile'
                )
                .to(
                    '.evl-mobile-section-three-lightsaber',
                    {
                        width: '100%',
                        minWidth: 1200,
                        duration: 3.5,
                    },
                    'luke-skywalker-reveal-mobile'
                )
                .to(
                    '.evl-mobile-overlay',
                    {
                        top: '0%',
                        duration: 3,
                    },
                    'section-overlay-top-mobile'
                )
                .to(
                    '.evl-mobile-overlay-wording',
                    {
                        delay: 2,
                        opacity: 1,
                        visibility: 'visible',
                        duration: 0,
                    },
                    'section-overlay-top-mobile'
                )
                .to(
                    '.evl-mobile-section-three-lightsaber',
                    {
                        delay: 2,
                        height: '0',
                    },
                    'section-overlay-top-mobile'
                )
                .to(
                    '.evl-mobile-outside-truck',
                    {
                        delay: 1,
                        display: 'none',
                        duration: 0,
                    },
                    'section-overlay-top-mobile'
                )
                .to('.evl-mobile-overlay', {
                    display: 'none',
                    duration: 0,
                })
                .to('.evl-mobile-section-three-launching-fleet-text p', {
                    opacity: 1,
                    duration: 2,
                })
                .to('.evl-mobile-section-three-launching-fleet-text p', {
                    opacity: 1,
                    duration: 2,
                });

            gsap.timeline({
                scrollTrigger: {
                    trigger: '.evl-mobile-wrap-2',
                    start: '+=10 top',
                    end: '+=200',
                    scrub: true,
                    invalidateOnRefresh: true,
                },
            }).to('.evl-header', {
                background:
                    'linear-gradient(rgb(1, 43, 80) 25%, rgba(1, 43, 80, 0.88) 50%, rgba(1, 43, 80, 0.75) 75%, rgba(1, 43, 80, 0) 100%)',
                paddingBottom: 15,
                duration: 1.5,
            });
        });

        // DESKTOP BELOW

        screenSize.add('(min-width: 1024px)', () => {
            gsap.set('.evl-section-one-grundon-title', {
                yPercent: -50,
                xPercent: -50,
                left: '50%',
                top: '50%',
                marginTop: '4.5vw',
            });

            gsap.set('.evl-mobile-overlay', {
                display: 'none',
            });

            (function () {
                const blurProperty = gsap.utils.checkPrefix('filter'),
                    blurExp = /blur\((.+)?px\)/,
                    getBlurMatch = (target) =>
                        (gsap.getProperty(target, blurProperty) || '').match(
                            blurExp
                        ) || [];

                gsap.registerPlugin({
                    name: 'blur',
                    get(target) {
                        return +getBlurMatch(target)[1] || 0;
                    },
                    init(target, endValue) {
                        let data = this,
                            filter = gsap.getProperty(target, blurProperty),
                            endBlur = 'blur(' + endValue + 'px)',
                            match = getBlurMatch(target)[0],
                            index;
                        if (filter === 'none') {
                            filter = '';
                        }
                        if (match) {
                            index = filter.indexOf(match);
                            endValue =
                                filter.substr(0, index) +
                                endBlur +
                                filter.substr(index + match.length);
                        } else {
                            endValue = filter + endBlur;
                            filter += filter ? ' blur(0px)' : 'blur(0px)';
                        }
                        data.target = target;
                        data.interp = gsap.utils.interpolate(filter, endValue);
                    },
                    render(progress, data) {
                        data.target.style[blurProperty] = data.interp(progress);
                    },
                });
            })();

            ScrollTrigger.refresh();

            gsap.set('.evl-grundon-title', {
                maxHeight: 500,
            });
            gsap.set('.evl-section-one-electricity', {
                top: '100%',
                fontSize: '6.3vw',
            });
            gsap.set('.evl-section-one-grundon-title .one', {
                width: '6.3vw',
            });

            gsap.set('.evl-section-four-how-its-going h3', {
                fontSize: '5.4vw',
            });

            gsap.set('.evl-section-five-whats-next h3', {
                fontSize: '6.1vw',
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: '.evl-wrap',
                    start: 'top top',
                    end: '+=6000',
                    scrub: true,
                    pin: true,
                },
            })
                .set('.evl-section-two-title', {
                    opacity: 0,
                })
                .to(
                    '.evl-section-one-grundon-title .one',
                    {
                        delay: 0.5,
                        opacity: 0,
                    },
                    'removal-of-letters-in-grundon-title'
                )
                .to(
                    '.evl-section-one-grundon-title .second',
                    {
                        delay: 0.5,
                        opacity: 0,
                    },
                    'removal-of-letters-in-grundon-title'
                )
                .to(
                    '.evl-next-chapter',
                    {
                        delay: 1,
                        opacity: 0,
                        duration: 1,
                    },
                    'removal-of-letters-in-grundon-title'
                )
                .to(
                    '.evl-lightsaber-container',
                    {
                        delay: 0,
                        top: '55%',
                        rotate: '-76deg',
                        left: '75%',
                        duration: 2,
                    },
                    'removal-of-letters-in-grundon-title'
                )
                .to(
                    '.evl-section-one-grundon-title',
                    {
                        left: '40%',
                        xPercent: -40,
                        top: '40%',
                        yPercent: -40,
                        duration: 3,
                        marginTop: '0vw',
                    },
                    'electricity-wording-entering-and-moving'
                )
                .to(
                    '.evl-section-one-grundon-title .one',
                    {
                        width: 0,
                        ease: 'none',
                        duration: 0.375,
                    },
                    'electricity-wording-entering-and-moving'
                )
                .to(
                    '.evl-grundon-title',
                    {
                        left: '-6.3vw',
                        duration: 3,
                    },
                    'electricity-wording-entering-and-moving'
                )
                .to(
                    '.evl-section-one-electricity',
                    {
                        fontSize: '9vw',
                        opacity: 1,
                        duration: 3,
                        left: '0vw',
                    },
                    'electricity-wording-entering-and-moving'
                )
                .to(
                    '.evl-lightsaber-container',
                    {
                        left: '78%',
                        rotate: '-112deg',
                        duration: 3,
                    },
                    'electricity-wording-entering-and-moving'
                )
                .to(
                    '.evl-section-one-grundon-title',
                    {
                        scale: 2.08,
                        left: '5%',
                        xPercent: -5,
                        top: '50%',
                        yPercent: -50,
                        duration: 1.5,
                    },
                    'run-on-scale'
                )
                .to(
                    '.evl-lightsaber-container',
                    {
                        scale: 2.5,
                        left: '55%',
                        duration: 1.5,
                    },
                    'run-on-scale'
                )
                .to(
                    '.evl-section-one-grundon-title',
                    {
                        top: '50%',
                        yPercent: -50,
                        duration: 2,
                    },
                    'removal-run-on'
                )
                .to(
                    '.evl-grundon-title',
                    {
                        opacity: 0,
                        maxHeight: 0,
                        duration: 2,
                    },
                    'removal-run-on'
                )
                .to(
                    '.evl-section-one-electricity',
                    {
                        delay: 0.5,
                        top: '0%',
                        duration: 2,
                    },
                    'removal-run-on'
                )
                .to(
                    '.evl-lightsaber-container',
                    {
                        top: '-100%',
                        rotate: '-158deg',
                        duration: 2,
                    },
                    'removal-run-on'
                )
                .to(
                    '.evl-lightsaber-container',
                    {
                        delay: 2.1,
                        top: '0%',
                        visibility: 'hidden',
                        rotate: '0',
                        duration: 0,
                    },
                    'removal-run-on'
                )
                .to(
                    '.evl-section-one-lightsaber',
                    {
                        delay: 2.1,
                        top: '0%',
                        rotate: '0',
                        duration: 0,
                    },
                    'removal-run-on'
                )
                .to(
                    '.evl-section-one-lightsaber-two',
                    {
                        delay: 2.1,
                        top: '100%',
                        rotate: '0',
                        duration: 0,
                    },
                    'removal-run-on'
                )

                .to(
                    '.evl-section-one-large-dots-container',
                    {
                        opacity: 0.85,
                        duration: 1,
                    },
                    'scale-and-start-fade'
                )
                .to(
                    '.evl-section-one-grundon-title',
                    {
                        scale: 2.5,
                        duration: 1,
                        zIndex: 0,
                    },
                    'scale-and-start-fade'
                )
                .to(
                    '#evl-section-two',
                    {
                        opacity: 0.24,
                    },
                    'scale-and-start-fade'
                )
                .to(
                    '.evl-lightsaber-container',
                    {
                        visibility: 'visible',
                    },
                    'scale-and-start-fade'
                )
                .to(
                    '.evl-section-one-lightsaber',
                    {
                        rotate: '-180deg',
                        duration: 2,
                    },
                    'scale-and-start-fade'
                )
                .to(
                    '.evl-section-one-lightsaber-two',
                    {
                        rotate: '-180deg',
                        duration: 2,
                    },
                    'scale-and-start-fade'
                )
                .to(
                    '.evl-lightsaber-container',
                    {
                        delay: 2,
                        visibility: 'hidden',
                        duration: 0,
                    },
                    'scale-and-start-fade'
                )
                .to(
                    '.evl-section-one-grundon-title',
                    {
                        scale: 2.89,
                    },
                    'electricity-title-fading-to-image'
                )
                .to(
                    '#evl-section-two img',
                    {
                        scale: 1.15,
                        bottom: '5%',
                    },
                    'electricity-title-fading-to-image'
                )
                .to(
                    '.evl-truck',
                    {
                        scale: 1.15,
                        bottom: '5%',
                        opacity: 0.1,
                    },
                    'electricity-title-fading-to-image'
                )
                .to(
                    '#evl-section-truck',
                    {
                        visibility: 'visible',
                    },
                    'electricity-title-fading-to-image'
                )
                .to(
                    '.evl-section-one-electricity div',
                    {
                        opacity: 0,
                        delay: 3,
                        duration: 0.2,
                    },
                    'electricity-title-fading-to-image'
                )
                .to(
                    '.evl-section-one-electricity-two',
                    {
                        delay: 1.2,
                        opacity: 1,
                        duration: 2,
                    },
                    'electricity-title-fading-to-image'
                )
                .to('.evl-wrap section', 1, { autoAlpha: 1, stagger: 1 })
                .to(
                    '.evl-truck',
                    {
                        opacity: 1,
                    },
                    'truck-journey-fade-in'
                )
                .to(
                    '.evl-section-two-title',
                    {
                        duration: 0.8,
                        opacity: 1,
                    },
                    'truck-journey-fade-in'
                )
                .to(
                    '#evl-section-two img',
                    {
                        duration: 2,
                        scale: 1.8,
                        bottom: '34%',
                    },
                    'section-2-scale'
                )
                .to(
                    '.evl-truck',
                    {
                        duration: 2,
                        scale: 1.8,
                        bottom: '34%',
                    },
                    'section-2-scale'
                );

            gsap.set('#evl-section-three .evl-section-three-where-it-started', {
                left: '50%',
                x: '-50%',
                position: 'absolute',
            });

            gsap.set('.evl-section-five-truck-front-on', {
                left: '50%',
                xPercent: -50,
                top: '50%',
                yPercent: -50,
                scale: 0.45,
            });

            gsap.set('.evl-section-three-lightsaber-red', {
                left: '50%',
            });

            gsap.set('.evl-section-three-lightsaber', {
                left: '50%',
            });

            gsap.set('.evl-overlay', {
                top: '150%',
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: '.evl-wrap',
                    start: '+=10 top',
                    end: '+=700',
                    scrub: true,
                    pin: false,
                },
            })
                .to(
                    '.evl-section-two-title',
                    {
                        duration: 3,
                        opacity: 0,
                    },
                    'transfer-together'
                )
                .to(
                    '.evl-truck',
                    {
                        bottom: '85%',
                        duration: 6,
                    },
                    'transfer-together'
                );

            gsap.set('.evl-section-three-sustainability-journey-text', {
                paddingTop: '9rem',
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: '.evl-wrap-2',
                    start: 'top top',
                    end: '+=16000',
                    scrub: true,
                    pin: true,
                    invalidateOnRefresh: true,
                },
            })
                .set('.evl-section-three-lightsaber', {
                    top: '-152px',
                })
                .set('.evl-section-three-glow-circle img', {
                    x: '-50%',
                    y: '-50%',
                })
                .set('.evl-bubbles-overlay', {
                    top: '100%',
                })
                .set('.evl-bubble-small, .evl-bubble-medium', {
                    top: '0%',
                })
                .set('.evl-section-five-truck-front-on', {
                    scale: 0.7,
                })
                .to(
                    '#evl-section-three .evl-section-three-where-it-started',
                    {
                        opacity: 1,
                        duration: 1.5,
                    },
                    'truck-swap'
                )
                .to(
                    '#evl-section-three .evl-section-three-where-it-started',
                    {
                        delay: 1.5,
                        duration: 2,
                        blur: 0,
                        left: '60%',
                        top: '10%',
                        textAlign: 'center',
                        scale: 1,
                        translateX: 0,
                    },
                    'blur-in-heading'
                )
                .to(
                    '.evl-overlay',
                    {
                        opacity: 1,
                        duration: 4,
                    },
                    'blur-in-heading'
                )
                .to(
                    '.evl-overlay',
                    {
                        top: '28%',
                        duration: 4,
                    },
                    'overlay-truck-movement'
                )
                .to(
                    '.evl-truck',
                    {
                        bottom: '100%',
                        duration: 4,
                    },
                    'overlay-truck-movement'
                )
                .to(
                    '.evl-section-three-lightsaber',
                    {
                        width: '100%',
                        minWidth: 5000,
                        duration: 3,
                    },
                    'luke-skywalker-reveal'
                )
                .to(
                    '.evl-truck',
                    {
                        bottom: '88%',
                        duration: 3,
                    },
                    'luke-skywalker-reveal'
                )
                .to(
                    '.evl-section-three-launching-fleet-text p',
                    {
                        height: 400,
                        duration: 3,
                    },
                    'luke-skywalker-reveal'
                )
                .to(
                    '.evl-section-three-launching-fleet-text',
                    {
                        delay: 2,
                        opacity: 0,
                        duration: 2.5,
                    },
                    'removal-of-launching-fleet-text'
                )
                .to('.evl-section-three-launching-fleet-text', {
                    display: 'none',
                })
                .to(
                    '.evl-overlay',
                    {
                        top: '0%',
                        duration: 2,
                    },
                    'overlay-to-top'
                )
                .to('#evl-section-truck', {
                    display: 'none',
                })
                .to(
                    '.evl-section-three-sustainability-journey-text',
                    {
                        position: 'relative',
                    },
                    'lightsaber-move'
                )
                .to(
                    '.evl-section-three-lightsaber',
                    {
                        left: '50%',
                    },
                    'lightsaber-move'
                )
                .to(
                    '.evl-section-three-lightsaber',
                    {
                        top: '90%',
                        duration: 2,
                    },
                    'lightsaber-reveal-of-text'
                )
                .to(
                    '.evl-section-three-sustainability-journey-text p',
                    {
                        opacity: 1,
                        duration: 2,
                    },
                    'lightsaber-reveal-of-text'
                )
                .to(
                    '.evl-section-three-since-then-text-p img',
                    {
                        delay: 0.5,
                        opacity: 1,
                        duration: 1.5,
                    },
                    'lightsaber-reveal-of-text'
                )
                .to('.evl-section-three-truck-graphic', {
                    display: 'flex',
                })
                .to(
                    '.evl-section-three-truck-graphic .evl-section-three-truck-img',
                    {
                        visibility: 'visible',
                        left: '0%',
                        duration: 3,
                    },
                    'reveal-of-truck-graphic'
                )
                .to(
                    '.evl-section-three-lightsaber-red',
                    {
                        rotate: -6,
                        top: '30%',
                        opacity: 1,
                        duration: 3,
                    },
                    'reveal-of-truck-graphic'
                )
                .to(
                    '.evl-section-three-truck-graphic .evl-section-three-truck-graphic-div',
                    {
                        delay: 2,
                        width: 0,
                        duration: 3,
                    },
                    'sustainable-text-out-truck-move-since-text-in'
                )
                .to(
                    '.evl-section-three-sustainability-journey-text',
                    {
                        delay: 2,
                        paddingTop: 0,
                        duration: 3,
                    },
                    'sustainable-text-out-truck-move-since-text-in'
                )
                .to(
                    '.evl-section-three-sustainability-journey-text p',
                    {
                        delay: 2,
                        opacity: 0,
                        duration: 3,
                    },
                    'sustainable-text-out-truck-move-since-text-in'
                )
                .to(
                    '.evl-section-three-lightsaber',
                    {
                        delay: 2,
                        rotate: -10,
                        duration: 2,
                    },
                    'sustainable-text-out-truck-move-since-text-in'
                )
                .to(
                    '.evl-section-three-lightsaber-red',
                    {
                        delay: 2,
                        rotate: -42,
                        duration: 3,
                    },
                    'sustainable-text-out-truck-move-since-text-in'
                )
                .to(
                    '.evl-section-three-since-then-text-p p',
                    {
                        delay: 3,
                        opacity: 1,
                        duration: 3,
                    },
                    'sustainable-text-out-truck-move-since-text-in'
                )
                .to(
                    '.evl-section-three-since-then-text-p img',
                    {
                        delay: 3,
                        opacity: 0,
                    },
                    'sustainable-text-out-truck-move-since-text-in'
                )
                .to(
                    '.evl-section-three-truck-graphic .evl-section-three-truck-img',
                    {
                        delay: 2.5,
                        left: '-100%',
                        opacity: 0,
                        duration: 3,
                    },
                    'truck-and-text-out'
                )
                .to(
                    '.evl-section-three-since-then-text-p p',
                    {
                        delay: 2.5,
                        opacity: 0,
                        duration: 3,
                    },
                    'truck-and-text-out'
                )
                .to('.evl-section-three-lightsaber', {
                    top: '11%',
                    position: 'fixed',
                    duration: 0,
                })
                .to('.evl-section-three-lightsaber-red', {
                    top: '14%',
                    position: 'fixed',
                    duration: 0,
                })
                .to(
                    '.evl-section-three-lightsaber-red',
                    {
                        rotate: -119,
                        top: '-20%',
                        left: '85%',
                        position: 'fixed',
                        duration: 4,
                    },
                    'battle-to-the-end'
                )
                .to(
                    '.evl-section-three-lightsaber',
                    {
                        rotate: -139,
                        top: '50%',
                        left: 0,
                        position: 'fixed',
                        duration: 4,
                    },
                    'battle-to-the-end'
                )
                .to(
                    '.evl-section-three-lightsaber-red',
                    {
                        opacity: 0,
                        rotate: -180,
                        duration: 1.5,
                    },
                    'lightsaber-out-glow-circle-in'
                )
                .to(
                    '.evl-section-three-lightsaber',
                    {
                        opacity: 0,
                        top: '100%',
                        rotate: -180,
                        duration: 1.5,
                    },
                    'lightsaber-out-glow-circle-in'
                )
                .to(
                    '.evl-section-three-glow-circle',
                    {
                        opacity: 1,
                        duration: 1.5,
                        scale: 1.9,
                    },
                    'lightsaber-out-glow-circle-in'
                )
                .to(
                    '.evl-section-three-glow-circle .evl-section-three-glow-circle-one',
                    {
                        delay: 0.5,
                        rotate: '-60deg',
                        duration: 1,
                    },
                    'lightsaber-out-glow-circle-in'
                )
                .to(
                    '.evl-section-three-glow-circle .evl-section-three-glow-circle-two',
                    {
                        delay: 0.5,
                        rotate: '60deg',
                        duration: 1,
                    },
                    'lightsaber-out-glow-circle-in'
                )
                .to(
                    '.evl-section-three-since-cta-one',
                    {
                        visibility: 'visible',
                    },
                    'lightsaber-out-glow-circle-in'
                )
                .to(
                    '.evl-section-three-glow-circle',
                    {
                        scale: 2.2,
                        duration: 1.5,
                    },
                    'cta-in-glow-circle-scale'
                )
                .to(
                    '.evl-section-three-cta',
                    {
                        scale: 1.5,
                        opacity: 1,
                        duration: 1.3,
                    },
                    'cta-in-glow-circle-scale'
                )
                .to(
                    '.evl-section-three-glow-circle .evl-section-three-glow-circle-one',
                    {
                        rotate: 0,
                        duration: 1.5,
                    },
                    'cta-in-glow-circle-scale'
                )
                .to(
                    '.evl-section-three-glow-circle .evl-section-three-glow-circle-two',
                    {
                        rotate: 0,
                        duration: 1.5,
                    },
                    'cta-in-glow-circle-scale'
                )
                .to(
                    '.evl-section-three-glow-circle',
                    {
                        delay: 1,
                        opacity: 0,
                        duration: 2,
                        scale: 7,
                    },
                    'cta-glow-circle-out'
                )
                .to(
                    '.evl-section-three-glow-circle .evl-section-three-glow-circle-one',
                    {
                        rotate: '60deg',
                        duration: 2,
                    },
                    'cta-glow-circle-out'
                )
                .to(
                    '.evl-section-three-glow-circle .evl-section-three-glow-circle-two',
                    {
                        rotate: '-60deg',
                        duration: 2,
                    },
                    'cta-glow-circle-out'
                )
                .to(
                    '.evl-section-three-cta img.evl-section-three-one',
                    {
                        delay: 1,
                        rotate: -50,
                        duration: 2,
                    },
                    'cta-glow-circle-out'
                )
                .to('.evl-section-three-glow-circle', {
                    display: 'none',
                })
                .to(
                    '.evl-section-three-cta',
                    {
                        scale: 0,
                        duration: 1.5,
                        opacity: 0,
                    },
                    'cta-out-truck-section-in'
                )
                .to(
                    '#evl-section-three',
                    {
                        top: '-100%',
                        duration: 0,
                    },
                    'cta-out-truck-section-in'
                )
                .to(
                    '.evl-overlay',
                    {
                        top: '-100%',
                        duration: 2.5,
                    },
                    'cta-out-truck-section-in'
                )
                .to(
                    '#evl-section-four .evl-section-four-truck',
                    {
                        delay: 1,
                        duration: 2,
                        motionPath: {
                            path: '#evl-section-four-road-line',
                            align: '#evl-section-four-road-line',
                            autoRotate: true,
                            start: 0.1,
                            end: 0.3,
                            alignOrigin: [0.5, 0.5],
                        },
                    },
                    'cta-out-truck-section-in'
                )
                .to(
                    '.evl-section-four-how-its-going h3',
                    {
                        delay: 0.75,
                        opacity: 1,
                        duration: 2,
                    },
                    'cta-out-truck-section-in'
                )
                .to('#evl-section-three', {
                    display: 'none',
                })
                .to(
                    '#evl-section-four .evl-background',
                    {
                        objectPosition: '0 40%',
                        duration: 2,
                    },
                    'how-its-going-truck-movement'
                )
                .to(
                    '.evl-section-four-how-its-going h3',
                    {
                        blur: 0,
                        duration: 2,
                    },
                    'how-its-going-truck-movement'
                )
                .to(
                    '#evl-section-four .evl-background',
                    {
                        objectPosition: '0 55%',
                        duration: 2,
                    },
                    'how-its-going-reveal'
                )
                .to(
                    '#evl-section-four .evl-section-four-truck',
                    {
                        duration: 5,
                        motionPath: {
                            path: '#evl-section-four-road-line',
                            align: '#evl-section-four-road-line',
                            autoRotate: true,
                            start: 0.3,
                            end: 0.5,
                            alignOrigin: [0.5, 0.5],
                        },
                    },
                    'how-its-going-reveal'
                )
                .to(
                    '.evl-section-four-how-its-going h3',
                    {
                        delay: 1,
                        fontSize: '1.4vw',
                        textAlign: 'left',
                        duration: 2,
                    },
                    'how-its-going-reveal'
                )
                .to(
                    '.evl-section-four-how-its-going',
                    {
                        delay: 1,
                        width: '25%',
                        duration: 2,
                    },
                    'how-its-going-reveal'
                )
                .to(
                    '.evl-section-four-how-its-going p',
                    {
                        delay: 3,
                        opacity: 1,
                        maxHeight: 400,
                        duration: 2,
                    },
                    'how-its-going-reveal'
                )
                .to(
                    '#evl-section-four .evl-background',
                    {
                        objectPosition: '0 70%',
                        duration: 2,
                    },
                    'how-its-going-shrink-and-text-reveal'
                )
                .to(
                    '#evl-section-four .evl-section-four-truck',
                    {
                        duration: 5,
                        motionPath: {
                            path: '#evl-section-four-road-line',
                            align: '#evl-section-four-road-line',
                            start: 0.5,
                            end: 0.7,
                            autoRotate: true,
                            alignOrigin: [0.5, 0.5],
                        },
                    },
                    'how-its-going-shrink-and-text-reveal'
                )
                .to(
                    '#evl-section-four .evl-section-four-truck',
                    {
                        duration: 5,
                        motionPath: {
                            path: '#evl-section-four-road-line',
                            align: '#evl-section-four-road-line',
                            start: 0.7,
                            end: 0.9,
                            autoRotate: true,
                            alignOrigin: [0.5, 0.5],
                        },
                    },
                    'how-its-going-content-reveal'
                )
                .to(
                    '.evl-section-four-how-its-going p',
                    {
                        overflow: 'visible',
                        duration: 0,
                    },
                    'how-its-going-content-reveal'
                )
                .to(
                    '.evl-section-four-how-its-going p .evl-section-four-how-its-going-p1',
                    {
                        opacity: 0,
                    },
                    'how-its-going-content-reveal'
                )
                .to(
                    '.evl-section-four-how-its-going p .evl-section-four-how-its-going-p2',
                    {
                        opacity: 1,
                    },
                    'how-its-going-content-reveal'
                )
                .to(
                    '.evl-section-four-how-its-going',
                    {
                        opacity: 0,
                        duration: 2,
                    },
                    'section-5-fade-in-how-its-going-fade-out'
                )
                .to(
                    '#evl-section-five',
                    {
                        opacity: 0.2,
                        visibility: 'visible',
                        duration: 2,
                    },
                    'section-5-fade-in-how-its-going-fade-out'
                )
                .to(
                    '.evl-section-five-whats-next h3',
                    {
                        opacity: 1,
                        duration: 2,
                    },
                    'section-5-fade-in-with-text'
                )
                .to(
                    '#evl-section-five',
                    {
                        opacity: 1,
                        duration: 2,
                    },
                    'section-5-fade-in-with-text'
                )
                .to(
                    '.evl-section-five-truck-front-on',
                    {
                        delay: 1,
                        opacity: 0.5,
                        duration: 2,
                    },
                    'section-5-fade-in-with-text'
                )
                .to(
                    '.evl-section-five-whats-next h3',
                    {
                        opacity: 1,
                        blur: 0,
                        duration: 2,
                    },
                    'section-5-whats-next-blur-in'
                )
                .to(
                    '#evl-section-five .evl-background',
                    {
                        opacity: 0,
                        duration: 2,
                    },
                    'section-5-whats-next-blur-in'
                )
                .to(
                    '.evl-section-five-truck-front-on',
                    {
                        opacity: 1,
                        duration: 2,
                    },
                    'section-5-truck-full-opacity-text-right'
                )
                .to(
                    '.evl-section-five-whats-next',
                    {
                        delay: 2,
                        left: '68%',
                        width: '25%',
                        top: '50%',
                        duration: 2,
                    },
                    'section-5-truck-full-opacity-text-right'
                )
                .to(
                    '.evl-section-five-whats-next h3',
                    {
                        delay: 2,
                        fontSize: '1.8vw',
                        textAlign: 'left',
                        duration: 2,
                    },
                    'section-5-truck-full-opacity-text-right'
                )
                .to(
                    '.evl-section-five-truck-front-on',
                    {
                        scale: 0.7,
                        duration: 2,
                    },
                    'section-5-truck-scale-content-in'
                )
                .to(
                    '.evl-section-five-whats-next p',
                    {
                        maxHeight: 600,
                        opacity: 1,
                        duration: 4,
                    },
                    'section-5-truck-scale-content-in'
                )
                .to(
                    '.evl-section-five-whats-next p',
                    {
                        overflow: 'visible',
                        duration: 0,
                    },
                    'whats-next-content-reveal-2'
                )
                .to(
                    '.evl-section-five-whats-next p .evl-section-five-whats-next-p1',
                    {
                        delay: 2.5,
                        opacity: 0,
                    },
                    'whats-next-content-reveal-2'
                )
                .to(
                    '.evl-section-five-whats-next p .evl-section-five-whats-next-p2',
                    {
                        delay: 2.5,
                        opacity: 1,
                    },
                    'whats-next-content-reveal-2'
                )
                .to(
                    '.evl-section-five-whats-next p .evl-section-five-whats-next-p2',
                    {
                        delay: 5,
                        opacity: 0,
                    },
                    'whats-next-content-reveal-3'
                )
                .to(
                    '.evl-section-five-whats-next p .evl-section-five-whats-next-p3',
                    {
                        delay: 5,
                        opacity: 1,
                    },
                    'whats-next-content-reveal-3'
                )
                .to(
                    '.evl-section-five-truck-front-on',
                    {
                        delay: 3,
                        scale: 1,
                        duration: 2,
                    },
                    'section-5-truck-scale-content-out'
                )
                .to(
                    '.evl-section-five-whats-next',
                    {
                        delay: 3,
                        opacity: 0,
                        duration: 2,
                    },
                    'section-5-truck-scale-content-out'
                )
                .to(
                    '#evl-section-five .evl-bubbles-overlay',
                    {
                        delay: 3,
                        top: '40%',
                        duration: 2,
                    },
                    'section-5-truck-scale-content-out'
                )
                .to(
                    '#evl-section-five .evl-bubble-small',
                    {
                        delay: 3,
                        top: '-30%',
                        duration: 2,
                    },
                    'section-5-truck-scale-content-out'
                )
                .to(
                    '#evl-section-five .evl-bubble-medium',
                    {
                        delay: 3,
                        top: '-20%',
                        duration: 2,
                    },
                    'section-5-truck-scale-content-out'
                )
                .to(
                    '.evl-section-five-truck-front-on',
                    {
                        delay: 0.5,
                        scale: 5,
                        opacity: 0.4,
                        duration: 3.5,
                    },
                    'section-5-truck-scale-out'
                )
                .to(
                    '#evl-section-five .evl-bubbles-overlay',
                    {
                        top: '-20%',
                        duration: 4,
                    },
                    'section-5-truck-scale-out'
                )
                .to(
                    '#evl-section-five .evl-bubble-small',
                    {
                        top: '-60%',
                        duration: 4,
                    },
                    'section-5-truck-scale-out'
                )
                .to(
                    '#evl-section-five .evl-bubble-medium',
                    {
                        top: '-40%',
                        duration: 4,
                    },
                    'section-5-truck-scale-out'
                )
                .to(
                    '#evl-section-five .evl-background',
                    {
                        delay: 0.8,
                        opacity: 1,
                        duration: 1,
                    },
                    'section-5-truck-scale-out'
                );

            gsap.timeline({
                scrollTrigger: {
                    trigger: '.evl-wrap-2',
                    start: '+=10 top',
                    end: 'bottom center',
                    scrub: true,
                    pin: false,
                    invalidateOnRefresh: true,
                },
            })
                .to(
                    '#evl-section-five .evl-bubbles-overlay',
                    {
                        top: '-100%',
                        duration: 2.5,
                    },
                    'section-five-truck-out-last'
                )
                .to(
                    '#evl-section-five .evl-bubble-small',
                    {
                        top: '-90%',
                        duration: 2.5,
                    },
                    'section-five-truck-out-last'
                )
                .to(
                    '#evl-section-five .evl-bubble-medium',
                    {
                        top: '-60%',
                        duration: 2.5,
                    },
                    'section-five-truck-out-last'
                )
                .to(
                    '.evl-section-five-truck-front-on',
                    {
                        scale: 6,
                        opacity: 0,
                        duration: 2.5,
                    },
                    'section-five-truck-out-last'
                )
                .to('.evl-section-five-truck-front-on', {
                    display: 'none',
                });
        });
    }

    if (document.querySelector('.evl-mobile-slider-container')) {
        const prev = document.querySelector('.evl-slider-prev');
        const next = document.querySelector('.evl-slider-next');
        const spinner = document.querySelector('.evl-mobile-slider-spinner');
        let rotate = 0;
        let slide = 0;

        prev.addEventListener('click', () => {
            if (slide === 4) {
                slide = 0;
            } else {
                slide++;
            }

            switch (slide) {
                case 4:
                    rotate -= 72;
                    break;
                case 3:
                    rotate -= 69.4;
                    break;
                case 2:
                    rotate -= 66.4;
                    break;
                case 1:
                    rotate -= 76.6;
                    break;
                default:
                    rotate -= 75.6;
            }

            spinner.style.transform =
                'translateX(-50%) rotate(' + rotate + 'deg)';
        });

        next.addEventListener('click', () => {
            if (slide === 0) {
                slide = 4;
            } else {
                slide--;
            }

            switch (slide) {
                case 4:
                    rotate += 76;
                    break;
                case 3:
                    rotate += 71.6;
                    break;
                case 2:
                    rotate += 69.4;
                    break;
                case 1:
                    rotate += 66.4;
                    break;
                default:
                    rotate += 76.6;
            }

            spinner.style.transform =
                'translateX(-50%) rotate(' + rotate + 'deg)';
        });
    }
}
